var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":_vm.top,"right":_vm.right,"bottom":_vm.bottom,"left":_vm.left,"content-class":_vm.contentClass,"close-delay":_vm.closeDelay,"value":_vm.value},on:{"input":_vm.onInput}},[_vm._t("activator",null,{"slot":"activator"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }